import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  Grid,
  Chip
} from '@mui/material';
import {
  AdminPanelSettings,
  Person,
  Email,
  Security,
  Dashboard,
  ArrowForward,
  CheckCircle,
  Warning
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AdminAccess: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToAdmin = () => {
    navigate('/admin/dashboard');
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <AdminPanelSettings sx={{ fontSize: 64, color: '#a5816d', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#a5816d' }}>
            Accès Administration
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
            Dashboard d'administration Allure
          </Typography>
        </Box>

        <Alert severity="info" sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Comment accéder au dashboard d'administration ?
          </Typography>
          <Typography variant="body2">
            Le dashboard d'administration est accessible uniquement aux utilisateurs ayant les privilèges administrateur.
          </Typography>
        </Alert>

        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                  <Person sx={{ mr: 1, color: '#a5816d' }} />
                  Comptes Admin
                </Typography>
                <List dense>
                  <ListItem>
                    <ListItemIcon>
                      <Email />
                    </ListItemIcon>
                    <ListItemText 
                      primary="admin@allure.com"
                      secondary="Compte administrateur principal"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Email />
                    </ListItemIcon>
                    <ListItemText 
                      primary="test@example.com"
                      secondary="Compte de test admin"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                  <Security sx={{ mr: 1, color: '#a5816d' }} />
                  Sécurité
                </Typography>
                <List dense>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle color="success" />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Accès protégé"
                      secondary="Vérification automatique des privilèges"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle color="success" />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Redirection automatique"
                      secondary="Vers le dashboard si non autorisé"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Fonctionnalités disponibles
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
            <Chip label="Gestion des utilisateurs" color="primary" />
            <Chip label="Détection de faux profils" color="primary" />
            <Chip label="Gestion des litiges" color="primary" />
            <Chip label="Dashboard global" color="primary" />
            <Chip label="Statistiques" color="primary" />
            <Chip label="Analytics" color="primary" />
          </Box>
        </Box>

        <Alert severity="warning" sx={{ mb: 4 }}>
          <Typography variant="body2">
            <strong>Note :</strong> Pour accéder au dashboard d'administration, vous devez être connecté avec un compte administrateur. 
            Si vous n'avez pas les privilèges nécessaires, vous serez automatiquement redirigé vers le dashboard utilisateur.
          </Typography>
        </Alert>

        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<Dashboard />}
            endIcon={<ArrowForward />}
            onClick={handleGoToAdmin}
            sx={{
              backgroundColor: '#a5816d',
              '&:hover': {
                backgroundColor: '#8B7355',
              },
              px: 4,
              py: 2
            }}
          >
            Accéder au Dashboard Admin
          </Button>
        </Box>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            URL directe : <code>/admin/dashboard</code>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default AdminAccess;
